export { getFileLike } from '@iotv/core-services'
